var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sub-title my-3"},[_vm._v("포트폴리오 평가")]),_c('div',_vm._l((_vm.portfolios),function(p,px){return _c('div',{key:px},[_vm._v(" "+_vm._s(_vm.portfolios.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }